import styled, { css } from "styled-components";

export const FeatureSectionContainer = styled.section`
  margin: 0 auto;
  padding: 56px 0 44px;
  max-width: 1756px;
  width: 100%;
  //inner height: 574px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;
  overflow: hidden;

  @media ${({ theme }) => theme.media.mobile} {
    margin: 0;
    padding: 88px 24px 68px;
    width: 100%;
    gap: 12px;
  }
`;

export const SliderContainer = styled.div`
  width: 592px;
  max-width: 592px;
  height: fit-content;
  max-height: 112px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 60px;

  @media ${({ theme }) => theme.media.mobile} {
    width: 100%;
    max-width: 100%;
    max-height: 105px;
  }
`;

export const ArrowButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  border-radius: 100px;
  border: 1px solid rgba(29, 29, 29, 0.1);
  outline: none;
  box-shadow: none;
  background: none;
  cursor: pointer;
  padding: 0;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(29, 29, 29, 0.04);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  @media ${({ theme }) => theme.media.mobile} {
    display: none;
  }
`;

export const ArrowIcon = styled.img.attrs(({ $variant }) => ({
  src: "/images/icons/arrow-right-black.svg",
  alt: `arrow-${$variant}`,
}))`
  width: 16px;
  height: 16px;

  ${({ $variant }) =>
    $variant === "left" &&
    css`
      transform: rotate(180deg);
    `}
`;

export const FeatureContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 24px 20px;
  width: 400px;
  text-align: center;
  position: relative;

  @media ${({ theme }) => theme.media.mobile} {
    width: 100%;
    padding: 24px 0;
  }
`;

export const FeatureTitle = styled.h4`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 24px;
  line-height: 1.5em;
  color: ${({ theme }) => theme.colors.orange};
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${({ theme }) => theme.media.mobile} {
    font-size: 22px;
    line-height: 1.3em;
  }
`;

export const FeatureDescription = styled.p`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 400;
  font-size: 16px;
  line-height: 1.5em;
  color: rgba(29, 29, 29, 0.5);
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const OrangeLine = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  transition: ${({ $isProgress }) =>
    $isProgress ? "width 6.5s linear 0.25s" : "none"};
  width: ${({ $isProgress }) => ($isProgress ? "100%" : "20px")};
  max-width: 100%;
  height: 0;
  border-bottom: 3px solid ${({ theme }) => theme.colors.orange};
`;

export const GreyLine = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0;
  border-bottom: 3px solid rgba(29, 29, 29, 0.1);
`;

export const CardContainer = styled.div`
  width: 100%;
  height: 440px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 50px;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${({ theme }) => theme.media.mobile} {
    margin: -6px -24px;
    width: calc(100% + 24px * 2);
    height: calc(188px + 6px * 2);
    gap: 10px;
  }
`;

export const ImageWrapper = styled.div`
  box-sizing: border-box;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
  transition: all 1s ease-in-out;

  ${({ $role }) =>
    $role.isCurrent
      ? css`
          width: 770px;
          height: 440px;
          opacity: 1;
          border: 0.573462px solid #f0f0f0;
          filter: drop-shadow(0px 4px 12px rgba(58, 83, 107, 0.08));
          border-radius: 24px;
        `
      : css`
          justify-content: flex-${$role.isPrev ? "end" : "start"};
          width: 443px;
          height: 252px;
          opacity: 0.5;
          border: 0.329365px solid #f0f0f0;
          filter: drop-shadow(0px 1.80968px 6.78629px rgba(58, 83, 107, 0.08));
          border-radius: 12px;
        `}

  @media ${({ theme }) => theme.media.mobile} {
    ${({ $role }) =>
      $role.isCurrent
        ? css`
            // align-self: stretch;
            align-self: center;
            width: calc(100% - 24px * 2);
            height: fit-content;
            max-height: 188px;
            border: 0.245025px solid #f0f0f0;
            filter: drop-shadow(
              0px 1.70909px 5.12727px rgba(58, 83, 107, 0.08)
            );
            border-radius: 11.12px;
            opacity: 1;
          `
        : css`
            opacity: 0.6;
            width: 260px;
            height: fit-content;
            max-height: 148px;
            border: 0.193193px solid #f0f0f0;
            filter: drop-shadow(
              0px 1.06149px 3.98059px rgba(58, 83, 107, 0.08)
            );
            border-radius: 7.04px;
          `}
  }
`;

export const FeatureImage = styled.img.attrs(({ $src, $isMobile }) => ({
  src: $isMobile && $src.image.mobile ? $src.image.mobile : $src.image.desktop,
  alt: $src.title,
}))`
  width: 100%;
  max-width: 100%;
  height: 100%;
  transition: all 1s ease-in-out;

  @media ${({ theme }) => theme.media.mobile} {
    width: 100%;
    height: auto;
    align-self: flex-start;
  }
`;
